import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PreviewImage,
  PrimaryButton,
  PrimaryDeleteButton,
  PrimaryRestoreButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function Publisher() {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleActivate = item => {
    const { is_active_flag, name } = item;
    ModalWarning(
      `Are you sure to ${is_active_flag ? "deactivate" : "restore"} ${name} ?`,
      `${is_active_flag ? "Deactivate" : "Restore"} Publisher`
    ).then(res => res?.isConfirmed && handleActivateUser(item));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/publisher`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleActivateUser = async item => {
    const { is_active_flag, publisher_id } = item;
    try {
      setLoadingPage(true);
      if (is_active_flag) {
        await axios.delete(`${hardBaseUrl}/publisher/${publisher_id}`, {
          headers,
        });
      } else {
        await axios.put(
          `${hardBaseUrl}/publisher-recovery/${publisher_id}`,
          {},
          { headers }
        );
      }
      ModalSuccess(
        `Successfully ${is_active_flag ? "Deactivate" : "Restore"} Publisher`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Publisher">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Publisher"
              onClick={() => history.push("/admin/parameter/publisher/add")}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          tooltipEdit="Update Publisher"
          handleEdit={item =>
            history.push(`/admin/parameter/publisher/${item.publisher_id}`)
          }
          customAction={item =>
            item?.is_active_flag ? (
              <PrimaryDeleteButton
                tooltipTitle="Deactivate Publisher"
                onClick={() => handleActivate(item)}
              />
            ) : (
              <PrimaryRestoreButton
                tooltipTitle="Restore Publisher"
                onClick={() => handleActivate(item)}
              />
            )
          }
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/publisher",
  },
  {
    label: "Publisher",
    active: true,
  },
];
const columnTable = [
  {
    name: "profile_image",
    title: "Logo",
    renderText: item => <PreviewImage imageUrl={item} />,
  },
  {
    name: "name",
    title: "Publisher",
  },
  {
    name: "publisher_id",
    title: "Publisher ID",
  },
  {
    name: "subdomain",
    title: "URL",
    renderText: item => item || "-",
  },
  {
    name: "email",
    title: "Email",
    renderText: item => item || "-",
  },
  {
    name: "phone",
    title: "Phone",
    renderText: item => item || "-",
  },
];
export default Publisher;
